import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import MobileLayout from '@/components/MobileLayout';
import ProtectedRoute from '@/components/ProtectedRoute';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import HomePage from '@/pages/HomePage';
import CheckInPage from '@/pages/CheckInPage';
import JoinActivityPage from '@/pages/JoinActivityPage';
import ReservationsPage from '@/pages/ReservationsPage';
import ScanPage from '@/pages/ScanPage';
import PercursoPage from '@/pages/PercursoPage';
import AboutPage from '@/pages/AboutPage';
import ProfilePage from '@/pages/ProfilePage';
import AccountSettingsPage from '@/pages/AccountSettingsPage';
import BadgesPage from '@/pages/BadgesPage';
import NotificationsPage from '@/pages/NotificationsPage';
import GuardianRegisterPage from '@/pages/GuardianRegisterPage';
import PrivacyPage from '@/pages/PrivacyPage';
import GuardianLayout from '@/components/GuardianLayout';
import EducandosPage from '@/pages/guardian/EducandosPage';
import EducandoPage from '@/pages/guardian/EducandoPage';
import GuardianAccountPage from '@/pages/guardian/GuardianAccountPage';

export default function App() {
  const { isAuthenticated, kind } = useAuthStore();

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        path="/register"
        element={isAuthenticated ? <Navigate to="/" replace /> : <RegisterPage />}
      />
      <Route
        path="/register/ee"
        element={isAuthenticated ? <Navigate to="/" replace /> : <GuardianRegisterPage />}
      />
      <Route
        path="/forgot-password"
        element={isAuthenticated ? <Navigate to="/" replace /> : <ForgotPasswordPage />}
      />
      {/* Readable by everyone, signed in or not. */}
      <Route path="/privacidade" element={<PrivacyPage />} />
      <Route
        path="/reset-password"
        element={isAuthenticated ? <Navigate to="/" replace /> : <ResetPasswordPage />}
      />

      {/* An Encarregado de Educação gets only their own screens; every
          Digger route falls through to the redirect for them. */}
      {kind === 'guardian' ? (
        <Route element={<ProtectedRoute />}>
          <Route element={<GuardianLayout />}>
            <Route path="/" element={<EducandosPage />} />
            <Route path="/educandos/:id" element={<EducandoPage />} />
            <Route path="/conta" element={<GuardianAccountPage />} />
          </Route>
        </Route>
      ) : (
        <>
          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<MobileLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/reservations" element={<ReservationsPage />} />
              <Route path="/scan" element={<ScanPage />} />
              {/* Target of the QR code printed at a Centro's entrance. Behind
                  ProtectedRoute, so an unauthenticated scan detours through login
                  and returns here to complete the check-in. */}
              <Route path="/checkin/:id" element={<CheckInPage />} />
              {/* Target of the QR code a session's leader shows on the first slide.
                  Same detour through login as the Centro code above. */}
              <Route path="/join/:token" element={<JoinActivityPage />} />
              <Route path="/percurso" element={<PercursoPage />} />
              <Route path="/history" element={<Navigate to="/percurso" replace />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile/settings" element={<AccountSettingsPage />} />
              <Route path="/profile/badges" element={<BadgesPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              {/* Legacy alias — keep /projects pointing to reservations for now */}
              <Route path="/projects" element={<Navigate to="/reservations" replace />} />
            </Route>
          </Route>
        </>
      )}

      {/* Default redirect */}
      <Route path="*" element={<Navigate to={isAuthenticated ? '/' : '/login'} replace />} />
    </Routes>
  );
}
